import problemsOverview from './problemsOverview.json';

import problemsMissedPie from './widgets/problemsMissedPie.json';
import problemsOpenedColumnChart from './widgets/problemsOpenedColulmnChart.json';
import problemsOpenedDataTable from './widgets/problemsOpenedDataTable.json';
import problemsClosedDataTable from './widgets/problemsClosedDataTable.json';
import problemsClosedColumnChart from './widgets/problemsClosedColulmnChart.json';
import problemsMissedColumnChart from './widgets/problemsMissedColumnChart.json';
import problemsMissedDataTable from './widgets/problemsMissedDataTable.json';
import problemsProductPie from './widgets/problemsProductPie.json';
import problemsCodePie from './widgets/problemsCodePie.json';
import problemsResolvedLineChart from './widgets/problemsResolvedLineChart.json';
import problemsPriorityPie from './widgets/problemsPriorityPie.json';

import filterQuarter from './widgets/filterQuarter.json';
import filterProduct from './widgets/filterProduct.json';
import filterService from './widgets/filterService.json';
import filterStatus from './widgets/filterStatus.json';

export default [
  problemsOverview,
  problemsMissedPie,
  problemsOpenedColumnChart,
  problemsOpenedDataTable,
  problemsClosedDataTable,
  problemsClosedColumnChart,
  problemsMissedColumnChart,
  problemsMissedDataTable,
  problemsProductPie,
  problemsCodePie,
  problemsResolvedLineChart,
  problemsPriorityPie,
  filterQuarter,
  filterProduct,
  filterService,
  filterStatus,
];
